import { DataObject } from "core/types/DataObject";
import { CreditCard } from "core/types/CreditCard";
import { Voucher } from "core/types/Voucher";

/**
 * core/types/PaymentMethod
 * ----------------------------------------------------------------------
 * @since     0.0.1
 */
export class PaymentMethod extends DataObject {
  /**
   * @type {CreditCard}
   */
  creditCard = null;

  /**
   * @type {Voucher}
   */
  voucher = null;

  /**
   * @type {number}
   */
  percent = null;

  /**
   * @type {number}
   */
  shippingPrice = null;

  /**
   * @type {number}
   */
  typeMethod = 1;

  /**
   * @param {number} percent 
   * @param {number} shippingPrice 
   * @param {number} typeMethod 
   * @param {CreditCard} creditCard 
   * @param {Voucher} voucher 
   */
  constructor (
    percent = null, 
    shippingPrice = null, 
    typeMethod = null, 
    creditCard = null, 
    voucher = null
  ) {
    super();

    this.percent = percent || null;
    this.shippingPrice = shippingPrice || null;
    this.typeMethod = typeMethod || null;
    this.creditCard = creditCard || null;
    this.voucher = voucher || null;
  }

  /**
   * Converte em POJO.
   * 
   * @param {boolean} notNullOnly 
   *     Se deve ignorar valores nulos ou indefinidos
   * @returns {object}
   * @override 
   */
  toObject (notNullOnly = false) {
    let keys = Object.keys(this),
        returnable = {};

    for (let key of keys) {
      if (!this[key]) continue;

      if (typeof this[key] !== "function") {
        if (this[key].toObject !== undefined) {
          returnable[key] = this[key].toObject(notNullOnly);
        } else if (this[key].toJSON !== undefined) {
          returnable[key] = this[key].toJSON(notNullOnly);
        } else {
          returnable[key] = this[key];
        }
      }
    }

    return returnable;
  }
}
